export default {
  title: 'Load Manager',
};
